import { urls } from "@selector/shared";
import { TrackEnum } from "@selector/shared/openapi";
import { useCallback } from "react";
import { Icons, TriggerButton } from "widgets";

import { useGenomeViewerStore } from "../../../store/store.ts";
import { routeWithBasename } from "../../../utils/route-with-basename.ts";
import { getEntityTypeFromTrackType } from "../../../utils/type-conversion.ts";

export const OpenSummaryPageButton = ({ id, trackId }: { id: number; trackId: string }) => {
  const trackType = useGenomeViewerStore((state) => state.tracks.get(trackId)?.trackType);

  const handleClick = useCallback(() => {
    if (!trackType) return;
    const type = getEntityTypeFromTrackType(trackType);
    window.open(routeWithBasename(`/${type}/${id}/summary`, urls), "_blank");
  }, [id, trackType]);

  return (
    <TriggerButton
      icon={<img src={Icons.Action.EntitySummaryBW} width={20} height={20} alt="Entity Summary" />}
      onPress={handleClick}
      label={"Open Summary Page"}
      isDisabled={trackType === TrackEnum.SEQUENCE}
    />
  );
};
